<ion-modal
  [attr.data-test]="dataTestAttribute"
  [isOpen]="modalTrigger"
  (didDismiss)="onDidDismiss()"
  [backdropDismiss]="true"
  [cssClass]="'release-notes-modal'">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title color="medium" class="modal-title">
          {{ 'PAGES.SETTINGS.RELEASE_NOTES' | translate }}
        </ion-title>
        <ion-buttons slot="end">
          <ion-button
            [attr.data-test]="dataTestAttribute + '-close'"
            (click)="close()"
            color="medium">
            <fa-icon icon="xmark"></fa-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      @if (releaseNotes.length === 0) {
        <ion-text color="medium" data-test="release-notes-empty">
          <p class="ion-text-center">
            {{ 'PAGES.SETTINGS.NO_RELEASE_NOTES' | translate }}
          </p>
        </ion-text>
      }
      @for (note of releaseNotes; track note.version; let last = $last) {
        <div class="version-block" data-test="release-notes-version">
          <div class="version-label">
            <span
              class="version-number"
              data-test="release-notes-version-number">
              V{{ note.version }}
            </span>
            <span class="version-date" data-test="release-notes-version-date">
              Build {{ note.buildNumber }} ·
              {{ formatDate(note.releaseDate) }}
            </span>
          </div>

          @if (featuresAndImprovements(note.changes); as whatsNew) {
            @if (whatsNew.length > 0) {
              <div class="type-label" data-test="release-notes-whats-new">
                {{ 'PAGES.SETTINGS.WHATS_NEW' | translate }}
              </div>
              @for (change of whatsNew; track change) {
                <div class="change-row" data-test="release-notes-change">
                  <span class="type-indicator type-new"></span>
                  <span class="change-text">{{ change }}</span>
                </div>
              }
            }
          }

          @if (note.changes.bugFixes && note.changes.bugFixes.length > 0) {
            <div class="type-label" data-test="release-notes-bug-fixes">
              {{ 'PAGES.SETTINGS.BUG_FIXES' | translate }}
            </div>
            @for (fix of note.changes.bugFixes; track fix) {
              <div class="change-row" data-test="release-notes-change">
                <span class="type-indicator type-fix"></span>
                <span class="change-text">{{ fix }}</span>
              </div>
            }
          }

          @if (isDevMode && note.internalChanges) {
            @if (
              note.internalChanges.bugFixes &&
              note.internalChanges.bugFixes.length > 0
            ) {
              <div class="type-label">
                {{ 'PAGES.SETTINGS.INTERNAL_BUG_FIXES' | translate }}
              </div>
              @for (fix of note.internalChanges.bugFixes; track fix) {
                <div class="change-row" data-test="release-notes-change">
                  <span class="type-indicator type-internal"></span>
                  <span class="change-text">{{ fix }}</span>
                </div>
              }
            }
            @if (
              note.internalChanges.notes &&
              note.internalChanges.notes.length > 0
            ) {
              <div class="type-label">
                {{ 'PAGES.SETTINGS.INTERNAL_NOTES' | translate }}
              </div>
              @for (n of note.internalChanges.notes; track n) {
                <div class="change-row" data-test="release-notes-change">
                  <span class="type-indicator type-internal"></span>
                  <span class="change-text">{{ n }}</span>
                </div>
              }
            }
          }

          @if (!last) {
            <hr class="version-divider" />
          }
        </div>
      }
    </ion-content>
  </ng-template>
</ion-modal>
